var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    _vm._l(_vm.options, function (option, index) {
      return _c(
        "div",
        { staticClass: "flex items-center justify-between" },
        [
          _c("label", {
            staticClass:
              "block text-sm font-medium leading-5 text-gray-700 w-1/3",
            domProps: { innerHTML: _vm._s(option.name) },
          }),
          _vm._v(" "),
          _c("form-quantity", {
            staticClass: "w-1/3",
            attrs: {
              max: _vm.groupMax - _vm.groupTotal + _vm.value[index].value,
            },
            model: {
              value: _vm.value[index].value,
              callback: function ($$v) {
                _vm.$set(_vm.value[index], "value", $$v)
              },
              expression: "value[index].value",
            },
          }),
          _vm._v(" "),
          _c("div", { staticClass: "w-1/3 text-right" }, [
            _vm._v(
              "\n            £" +
                _vm._s(
                  (_vm.value[index].value * option.price).toLocaleString(
                    undefined,
                    { minimumFractionDigits: 2, maximumFractionDigits: 2 }
                  )
                ) +
                "\n        "
            ),
          ]),
        ],
        1
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }